<template>
    <div>
        <b-row>
            <b-col cols="12">
                <app-form-text-input
                    label="Nombre"
                    v-model="itemType.name"
                    :required="true"
                    :hasError="$v.itemType.name.$error"
                    errorMessage="Debe escribir el nombre"
                    @input="$v.itemType.name.$touch()"
                />
            </b-col>
            <b-col cols="12">
                <app-form-textarea-input
                    label="Descripción"
                    v-model="itemType.description"
                />
            </b-col>
            <b-col cols="12" md="6">
                <app-form-select-input
                    label="¿Requiere mantenimiento?"
                    :options="maintenanceRequiredOptions"
                    v-model="itemType.maintenanceRequired"
                    :hasError="$v.itemType.maintenanceRequired.$error"
                    errorMessage="Debe especificar si requiere mantenimiento o no"
                    @change="$v.itemType.maintenanceRequired.$touch()"
                />
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    v-if="!!itemType.maintenanceRequired"
                    label="Periodo (días)"
                    v-model="itemType.maintenancePeriod"
                    :required="true"
                    :hasError="$v.itemType.maintenancePeriod.$error"
                    errorMessage="Debe escribir el periodo en un formato valido"
                    @input="$v.itemType.maintenancePeriod.$touch()"
                />
            </b-col>
            <b-col cols="12">
                <b-form-group
                    title="Campos requeridos"
                    label="Campos requeridos"
                >
                    <b-form-checkbox
                        v-for="field in fields"
                        v-model="requiredFields"
                        :value="field.id"
                        :key="field.id"
                        >{{ field.name }}</b-form-checkbox
                    >
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6" lg="4"></b-col>
        </b-row>
    </div>
</template>
<script>
import itemsRepository from '../../../../repositories/items.repository.js'
import FormTextInput from '../../../UI/Controls/Forms/FormTextInput.vue'
import FormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue'
import FormTextareaInput from '../../../UI/Controls/Forms/FormTextareaInput.vue'
import { required, numeric, requiredIf } from 'vuelidate/lib/validators'
export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appFormTextareaInput: FormTextareaInput,
    },

    props: {
        myType: {
            default: null,
        },
        onSave: {
            type: Function,
        },
    },

    data: () => ({
        maintenanceRequiredOptions,
        itemType: {
            name: '',
            description: '',
            maintenanceRequired: false,
            maintenancePeriod: 0,
            restricted: false,
        },
        requiredFields: [],
        fields: [],
    }),

    validations: {
        itemType: {
            name: { required },
            maintenanceRequired: { required },
            maintenancePeriod: {
                numeric,
                required: requiredIf(function() {
                    return !!this.itemType.maintenanceRequired
                }),
            },
        },
    },
    watch: {
        myType(val) {
            this.fillForm()
        },
    },

    methods: {
        async save() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.error(
                    'Debe diligenciar el formulario correctamente'
                )

            const payload = {
                itemType: this.itemType,
                fields: this.requiredFields,
            }

            const { data } = await repo.post('item-types', payload)

            if (data.status) {
                toastr.success('Tipo de item creado satisfactoriamente')
                this.$emit('created', data.result)
            } else {
                toastr.error(data.msg)
                return false
            }
        },
        async updateItemType(id) {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }
            const payload = {
                itemType: this.itemType,
                fields: this.requiredFields,
            }
            const { data } = await repo.put(
                `item-types/${this.myType.id}`,
                payload
            )
            if (data.status) {
                Object.keys(this.itemType).map(key => (this.itemType[key] = ''))
                this.$emit('updated', data)
                this.$v.$reset()
            } else {
                toastr.error('Ocurrio un error al actualizar la información')
            }
        },
        saveOrUpdate() {
            if (!!this.myType) {
                this.updateItemType()
            } else {
                this.save()
            }
        },
        fillForm() {
            if (Object.keys(this.myType).length !== 0) {
                this.itemType.name = this.myType.name
                this.itemType.slug = this.myType.slug
                this.itemType.description = this.myType.description
                this.itemType.maintenanceRequired = this.myType.maintenance_required
                this.itemType.maintenancePeriod =
                    this.myType.maintenance_period !== null ? this.myType.maintenance_period + '' : '0'
                this.itemType.restricted = this.myType.restricted
                if(this.myType.fields.length !== 0){
                    let aux = []
                    this.myType.fields.map(function(value, key) {
                        aux.push(value.id)
                    });
                    this.requiredFields = aux
                } else {
                    this.requiredFields = []
                }
            } else {
                this.cleanFields()
            }
        },
        cleanFields() {
            Object.keys(this.itemType).map(key => (this.itemType[key] = ''))
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.requiredFields = []
        },
        handleRestriction() {
            this.itemType.restricted = !this.itemType.restricted
        },
        async loadFields() {
            const { data } = await repo.get('fields')
            this.fields = data
        },
    },

    created() {
        this.$bus.$on('item-type-form.save', this.saveOrUpdate)
        this.$bus.$on('item-type-form.clean', this.cleanFields)
    },
    mounted() {
        this.loadFields()
    },
    beforeDestroy() {
        this.$bus.$off('item-type-form.save')
    },
}

const maintenanceRequiredOptions = [
    { name: 'Si', id: 1 },
    { name: 'No', id: 0 },
]
</script>
